module.exports = __webpack_public_path__ + "media/images/bolinha-azul-de538870504ef951851fa01ad2a7f43a.svg";